module.exports = __webpack_public_path__ + "RobotoRegular.dcba2c51242c52fd88b5.woff";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoRegular.woff
// module id = ../../../../../src/fonts/RobotoRegular.woff
// module chunks = 3